import _ from 'lodash';
import toastr from 'toastr';
import apiService from '../../../../service/apiService';
import {
  columnDefsForCustomGlobalAttributeandFormAttribute,
  validationHelper,
  processFormElementsforAttachment,
} from '../helper';

const component = 'ExportManagement';

export const types = {
  LOADING_STATE: `${component}_LOADING_STATE`,
  TASK_TYPE_CHANGE: `${component}_TASK_TYPE_CHANGE`,
  FORM_DETAIL_BUTTON_VISIBLE_STATE: `${component}_FORM_DETAIL_BUTTON_VISIBLE_STATE`,
  SCHEMA_UPDATE_FOR_CUSTOM_ATTRIBUTE: `${component}_SCHEMA_UPDATE_FOR_CUSTOM_ATTRIBUTE`,
  FORM_SCHEMA: `${component}_FORM_SCHEMA`,
  DATE_RANGE_CHANGE: `${component}_DATE_RANGE_CHANGE`,
  ROW_DATE_CHANGE: `${component}_ROW_DATE_CHANGE`,
  SHOW_TABLE: `${component}_SHOW_TABLE`,
  COLUMNDEFS_CHANGE_FOR_FORM_DATA: `${component}_COLUMNDEFS_CHANGE_FOR_FORM_DATA`,
  ROW_DATA_CHANGE_FOR_FORM_DATA: `${component}_ROW_DATA_CHANGE_FOR_FORM_DATA`,
  CLEAR_REDUX_STATE: `${component}_CLEAR_REDUX_STATE`,
  FLAG_SETTINGS: `${component}_FLAG_SETTINGS`,
  ADD_FORM_FIELDS: `${component}_ADD_FORM_FIELDS`,
};

export function onflagChange(flag) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.FLAG_SETTINGS, flagSetting: flag });
    } catch (e) {
      console.error(e);
    }
  };
}

export function loader(state) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.LOADING_STATE, loadingState: state });
    } catch (e) {
      console.error(e);
    }
  };
}

export function changeDateRange(data) {
  return async (dispatch) => {
    try {
      const { startDate, endDate } = data;
      dispatch({ type: types.DATE_RANGE_CHANGE, startDate, endDate });
    } catch (e) {
      console.error(e);
    }
  };
}

export function ontaskTypeChange({ value, taskTypeList }) {
  return async (dispatch) => {
    try {
      const taskTypeObj = _.isEmpty(taskTypeList.filter((e) => e.id === value))
        ? {}
        : taskTypeList.filter((e) => e.id === value)[0];

      const flagVisibilitySetting = {
        customAttribute: !_.isEmpty(
          Object.keys(taskTypeObj.schema)
            .map((e) => e.includes('c_'))
            .filter((e) => e)
        ),
        globalAttribute: !_.isEmpty(_.get(taskTypeObj, 'globalAttributes', '')),
        formData: !_.isEmpty(_.get(taskTypeObj, 'formSchemaId', '')),
      };
      dispatch({ type: types.TASK_TYPE_CHANGE, id: value, flagVisibilitySetting });
    } catch (e) {
      console.error(e);
    }
  };
}

export function formDetailVisibleState(state) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.FORM_DETAIL_BUTTON_VISIBLE_STATE, formDetailButtonVisibleState: state });
    } catch (e) {
      console.error(e);
    }
  };
}

export function formSchemaUpdate(obj) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.FORM_SCHEMA, formSchema: obj });
    } catch (e) {
      console.error(e);
    }
  };
}

export function columnDefsforGlobalandtaskTypeAttibute(columndefs = []) {
  return async (dispatch) => {
    try {
      dispatch({
        type: types.SCHEMA_UPDATE_FOR_CUSTOM_ATTRIBUTE,
        columndefsforGlobalandtaskTypeAttibute: columndefs,
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export function showTable(state) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SHOW_TABLE, showTable: state });
    } catch (e) {
      console.error(e);
    }
  };
}

function attachmentUrl({ response, formSchema, formData }) {
  if (formData) {
    const resp = [];
    processFormElementsforAttachment(_.get(formSchema, 'data.elements') || [], resp, response, null);

    return resp;
    // return _.uniqBy(resp, 'id');
  }
  return [];
}

function addFormField(fields) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.ADD_FORM_FIELDS, formFields: fields });
    } catch (e) {
      console.error(e);
    }
  };
}

async function getRowDatafromNexttoken({
  taskTypeIdSelected,
  startDate,
  endDate,
  fieldId,
  formSchemaIds,
  formData,
  dispatch,
  formSchema,
}) {
  const rowData = await apiService.bulkExportTaskData({
    taskTypeIds: [taskTypeIdSelected],
    fieldId,
    fromDate: startDate,
    toDate: endDate,
    enableBrotli: true,
    enableGzip: false,
    formSchemaIds: !formData && _.isEmpty(formSchemaIds) ? [] : formSchemaIds,
    dispatch,
  });
  let response = rowData;
  let responseTemp = null;
  const modifiedOn = _.get(response[response.length - 1], 't_modifiedOn');

  while ((_.isNull(responseTemp) && !_.isEmpty(response)) || !_.isEmpty(responseTemp)) {
    try {
      responseTemp = await apiService.bulkExportTaskData({
        taskTypeIds: [taskTypeIdSelected],
        fieldId,
        fromDate: startDate,
        toDate: endDate,
        enableBrotli: true,
        enableGzip: false,
        formSchemaIds: !formData && _.isEmpty(formSchemaIds) ? [] : formSchemaIds,
        nextToken: [new Date(modifiedOn).getTime(), response[response.length - 1].id],
      });

      response = [...response, ...responseTemp];
    } catch (e) {
      toastr.error('Something went wrong');
      console.error(e);
    }
  }
  const formFields = attachmentUrl({ response, formSchema, formData });
  dispatch(addFormField(formFields));
  // const reponseWithAttachementURL = await attachmentUrl({ response, formSchema, formData });
  return response;
}

async function getRowDataandColumnDefs({
  taskTypeIdSelected,
  startDate,
  endDate,
  taskTypeObj,
  globalAttributeList,
  fieldId,
  formSchemaIds = [],
  formSchema,
  flagSetting,
  dispatch,
}) {
  const { customAttribute, globalAttribute, formData } = flagSetting;
  const rowData = await getRowDatafromNexttoken({
    taskTypeIdSelected,
    startDate,
    endDate,
    taskTypeObj,
    globalAttributeList,
    fieldId,
    formSchemaIds,
    formSchema,
    dispatch,
    formData,
  });

  const tempcolumnDefs = columnDefsForCustomGlobalAttributeandFormAttribute({
    schema: _.get(taskTypeObj, 'schema', {}),
    globalAttribute: globalAttribute ? globalAttributeList : [],
    globalAttributeIds: globalAttribute ? _.get(taskTypeObj, 'globalAttributes') : [],
    formSchema: formData ? formSchema : [],
    customAttribute,
  });

  return { rowData, tempcolumnDefs };
}

export function getRowData(data) {
  return async (dispatch, getState) => {
    try {
      dispatch(loader(true));
      const { taskTypeList, taskTypeIdSelected, globalAttributeList, selectedDateRange, flagSetting } = data;
      const { formData } = flagSetting;
      const fieldId = _.get(getState(), 'appReducer.selectedField.id', '');
      let rowData = [];
      let tempcolumnDefs = [];
      let formSchema = null;
      let { startDate, endDate } = selectedDateRange;
      const { validation, message } = validationHelper(selectedDateRange, taskTypeIdSelected, fieldId);
      if (!validation) {
        throw new Error(message);
      }
      const taskTypeObj = taskTypeList.filter((e) => e.id === taskTypeIdSelected);

      if (formData) {
        const taskTypeFormSchemaId = taskTypeList
          .filter((e) => e.id === taskTypeIdSelected && e.formSchemaId)
          .map((e) => e.formSchemaId);

        if (_.isEmpty(taskTypeFormSchemaId)) {
          dispatch(formDetailVisibleState(false));
        }
        if (!_.isEmpty(taskTypeFormSchemaId)) {
          const formSchemas = await apiService.getFormsByFormIds(taskTypeFormSchemaId);
          formSchema = [...formSchemas];
          dispatch(formDetailVisibleState(true));

          // dispatch(formSchemaUpdate(formSchemas[0]));
        }
      }
      if (startDate === endDate) {
        startDate = new Date(startDate);
        endDate = new Date(startDate);
        endDate.setHours(startDate.getHours() + 23);
        endDate.setMinutes(startDate.getMinutes() + 59);
        endDate = new Date(endDate).toISOString();
        startDate = new Date(startDate).toISOString();
      }

      // if (getAttribute) {
      const response = await getRowDataandColumnDefs({
        taskTypeObj: taskTypeObj[0],
        taskTypeIdSelected,
        startDate,
        endDate,
        globalAttributeList,
        fieldId,
        flagSetting,
        formSchema: formData && _.isArray(formSchema) ? formSchema[0] : {},
        formSchemaIds: formData ? [_.get(formSchema[0], 'id')] || [] : [],
        dispatch,
      });
      rowData = _.get(response, 'rowData', []);
      tempcolumnDefs = _.get(response, 'tempcolumnDefs', []); // template def is coming from const file not from api response
      dispatch(showTable(true));
      dispatch(columnDefsforGlobalandtaskTypeAttibute(tempcolumnDefs));
      dispatch({ type: types.ROW_DATE_CHANGE, rowData });

      if (_.isEmpty(rowData)) {
        throw new Error('No data found');
      }
      dispatch(loader(false));
    } catch (e) {
      console.error(e);
      toastr.error(e);
      dispatch(loader(false));
    }
  };
}

export function clearReduxStore() {
  return async (dispatch) => {
    try {
      dispatch({ type: types.CLEAR_REDUX_STATE });
    } catch (e) {
      console.error(e);
    }
  };
}
